"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 * 搜索中状态时渲染
 */
var _default = function _default(props) {
  var locale = props.locale;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cn-address--search-loading-container cn-address-search-text"
  }, locale.searching);
};
exports["default"] = _default;
module.exports = exports.default;
module.exports.default = exports.default;